import { variableTypeOptions, type VariableType } from 'shared/src'

const FORM_FILLER_TYPES: VariableType[] = ['string', 'int', 'float', 'boolean']

export const getVariableTypeOptions = (t: (key: string) => string) =>
  variableTypeOptions
    .filter((o) => FORM_FILLER_TYPES.includes(o.value))
    .map((o) => ({ value: o.value, label: t(`variables.type_${o.value}`) }))
